Ext.define('SA.BarChartRenderer', {
    statics: {
        getBorderedSize(svgResult) {
            var svgSize = svgResult.getSize();

            return {...svgSize, width: svgSize.width + 2, height: svgSize.height + 2};
        },

        render({space, attribute, data, formatCfg}) {
            var renderer = new SA.BarChartRenderer({space, attribute, data, formatCfg}),
                minSizeSvg = renderer.renderAtMinSize(),
                firstPassEnlargementSvg = renderer.renderWithBaseSize(this.getBorderedSize(minSizeSvg)),
                secondPassEnlargementSvg = renderer.renderWithBaseSize(this.getBorderedSize(firstPassEnlargementSvg));

            return secondPassEnlargementSvg.getEl();
        }
    },

    constructor({space, attribute, data, formatCfg}) {
        this.space = space;
        this.barCount = data.length;
        this.svgParams = {attribute, data, formatCfg};
    },

    render({barWidth, yAxisHeight}) {
        var el = SA.BarChartSvg.create({barWidth, yAxisHeight, ...this.svgParams});

        return new SA.BarChartSvgResult({el, barWidth, yAxisHeight});
    },

    renderAtMinSize() {
        var barWidth = SA.BarChartConfig.barMinWidth,
            yAxisHeight = SA.BarChartConfig.yAxisMinHeight;

        return this.render({barWidth, yAxisHeight});
    },

    renderWithBaseSize(baseSize) {
        var {extraSpace} = SA.ConstrainedSize.get({maxSize: this.space, intrinsicSize: baseSize}),
            barWidth = Math.min(baseSize.barWidth + (extraSpace.width / this.barCount), SA.BarChartConfig.barMaxWidth),
            yAxisHeight = Math.min(baseSize.yAxisHeight + extraSpace.height, SA.BarChartConfig.yAxisMaxHeight);

        return this.render({barWidth, yAxisHeight});
    }
});